import BTSBanner from './BTSBanner'

export default BTSBanner
